<template>
    <div>
        <p><b>Actions</b></p>

        <draggable :group="'action'" :list="actions" class="list-group" handle=".handle">
            <b-card v-for="(action, idx) in actions" :key="idx">
                <b-container style="margin: 0; padding: 0; max-width: none;">
                    <b-row>
                        <b-col cols="4">
                            Nom
                            <b-input v-model="action.name"></b-input>
                        </b-col>
                        <b-col cols="4">
                            Projet
                            <b-select @change="update_project(idx)" v-model="action.project_id" :options="projects"></b-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col v-if="delete_option" cols="4">   
                            Supprimer les lignes                 
                            <b-checkbox v-model="action.del"></b-checkbox>
                        </b-col>
                        <b-col cols="4">   
                            Résultats indépendants                 
                            <b-checkbox v-model="action.independant"></b-checkbox>
                        </b-col>
                        <b-col cols="4">
                            Voir le traitement automatiquement
                            <b-checkbox v-model="action.view_treatment" />
                        </b-col>
                    </b-row>
                </b-container>
                <p>Colonnes de résultats</p>
                <div v-for="(column, idx_column) in action.columns" :key="idx_column">
                    <b-input style="width:500px; display: inline" v-model="action.columns[idx_column]"></b-input>
                    <b-button variant="link" @click="del_column(idx, idx_column)"><i class="fas fa-trash"></i></b-button>
                </div>
                <br />
                <b-button @click="add_column(idx)">Ajouter une colonne</b-button>
                <br />

                <b-container style="margin: 0; padding: 0; max-width: none;">
                    <b-row>
                        <b-col cols="4">
                            Utiliser les colonnes indiquées dans le scénario
                            <b-checkbox v-model="action.use_results_column" />
                        </b-col>
                        <b-col cols="4">
                            Afficher les résultats en dessous
                            <b-checkbox v-model="action.view_results_below" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="4">
                            Saut de ligne
                            <b-input v-model="action.return_line" />
                        </b-col>
                        <b-col cols="4">
                            Montrer les paramètres par défaut
                            <b-checkbox v-model="action.default_view_parameters" />
                        </b-col>
                    </b-row>
                </b-container>

                <br />
                <c_treatment_params :type_save="action.params_save" :ref="'treatment_params_' + idx" @change="change_treatment_params(idx)" :dashboard="false" :edit_visible="true"></c_treatment_params>

                <b-button variant="link" class="handle"><i class="fas fa-arrows-alt"></i></b-button>
                <b-button variant="link" @click="del(idx)"><i class="fas fa-trash"></i></b-button>
            </b-card>
        </draggable>
        <br />
        <b-button @click="add">Ajouter une action</b-button>
    </div>

</template>

<script>
    import draggable from "vuedraggable";

    const clone = require("clone");

    import c_treatment_params from "../params.vue"

    export default {
        name: "actionBuilder",
		components: {
            draggable,
            c_treatment_params
        },
        props: {
            delete_option: {
                default: false
            },
            projects: {},
            projects_obj: {}
        },
        data: function () {
            return {
                actions: []
            };
        },
        methods: {
            async update_project(idx) {
                console.log("update_project")
                this.actions[idx].treatment_params = this.projects_obj[this.actions[idx].project_id].details.treatment_params || [];
                this.$set(this.actions[idx], "params_save", this.projects_obj[this.actions[idx].project_id].details.details ? (this.projects_obj[this.actions[idx].project_id].details.details.user_params_save || "") : "");

				await this.$refs['treatment_params_' + idx][0].set(this.actions[idx].treatment_params, null, this.actions[idx].treatment_params_arr || []);
            },
			change_treatment_params(idx)
			{
                console.log('change_treatment_params ' + idx)
				//this.actions[idx].treatment_params = this.$refs['treatment_params_' + idx][0].get_obj();
				//this.actions[idx].treatment_params_arr = this.$refs['treatment_params_' + idx][0].get();
			},
            del_column(idx, idx_column)
            {
                this.actions[idx].columns.splice(idx_column, 1);
                this.$set(this.actions[idx], "column", this.actions[idx].columns);
            },
            del(idx)
            {
                this.actions.splice(idx, 1);
            },
            add()
            {
                this.actions.push({
                    name: "",
                    project_id: "",
                    del: false,
                    columns: [],
                    treatment_params: []
                })
            },
            add_column(idx)
            {
                if (!this.actions[idx].columns)
                    this.actions[idx].columns = [];
                this.actions[idx].columns.push("");
                this.$set(this.actions[idx], "column", this.actions[idx].columns);
            },
            async load(data)
            {
                var self = this;

                this.actions = [];
                if (data && data.actions)
                    this.actions = data.actions;

				self.$nextTick(async function () {
                    for (var i = 0; i < self.actions.length; i++)
                    {
                        if (self.actions[i].project_id)
                        {
                            await self.$refs['treatment_params_' + i][0].set(self.projects_obj[self.actions[i].project_id].details.treatment_params || [], self.actions[i].treatment_params || {}, self.actions[i].treatment_params_arr || []);
                        }
                    }
                });
            },
            async save()
            {
                for (var i = 0; i < this.actions.length; i++)
                {
                    this.actions[i].treatment_params = this.$refs['treatment_params_' + i][0].get_obj();
                    this.actions[i].treatment_params_arr = this.$refs['treatment_params_' + i][0].get(false);
                }

                return {
                    actions: this.actions
                }
            }
        },
        mounted: function () {

        },
    }


</script>